export const cellParamTypeName = {
  Boolean: "Boolean",
};

export const amountTypeIds = {
  Installment: 4,
};
